import styled, { createGlobalStyle, keyframes } from "styled-components";

// Keyframes for animations
const fadeIn = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

// Styled components
export const LoadingContent = styled.div`
  position: relative;
  font-size: var(--fs-xl);
  display: flex;
  gap: calc(var(--u) * 50);
  flex-direction: column;
  align-items: center;
  text-align: flex-start;
`;

export const EmailContent = styled.div`
  position: relative;
  font-size: var(--fs-xl);
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: flex-start;
`;

export const UserContent = styled.div`
  position: relative;
  font-size: var(--fs-xl);
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const SubsidiaryContent = styled.div`
  position: relative;
  font-size: var(--fs-xl);
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const PasswordContent = styled.div`
  position: relative;
  font-size: var(--fs-xl);
  transition: 0.5s 0.5s ease-in-out 0.5s;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const ContentTitle = styled.h4<{ $textAlign: string }>`
  text-align: ${(props) => props.$textAlign};
  font-weight: bold;
  font-size: calc(var(--u) * 26);
  z-index: 1;
`;

export const ContentSubtitle = styled.h3<{ $textAlign: string }>`
  text-align: ${(props) => props.$textAlign};
  color: #018dea;
  font-weight: bold;
  font-size: var(--fs-xl);
  margin-bottom: var(--sp-15);
  z-index: 1;
`;

export const TermsText = styled.div`
  color: #404040;
  align-self: flex-start;
  font-weight: bold;
  font-size: var(--fs-md);
  margin-top: var(--sp-15);
  z-index: 1;
`;

export const TextInput = styled.div`
  margin: var(--sp-20) 0;
  width: 100%;
  font-size: var(--fs-base);
  position: relative;
  border: 1px solid ${({ theme }) => theme.colors.selection};
  border-radius: 6px;
  margin-right: var(--sp-10);
  display: flex;
  align-items: center;

  input {
    width: 100%;
    padding: var(--sp-4) var(--sp-2) var(--sp-2) var(--sp-4);
    height: calc(var(--u) * 50);
    border: 1px solid #bbbbbb;
    border-radius: 5px;
    transition: outline 0.2s ease;
  }

  input:focus {
    box-shadow: 0 0 0 1px #e8e8e8,
      0 0 0 3px ${({ theme }) => theme.colors.selection};
  }

  label {
    width: fit-content;
    padding: 0 var(--sp-5);
    transition: all 0.1s ease-in-out;
    position: absolute;
    top: -30%;
    left: calc(var(--u) * 20);
    pointer-events: none;
    background: #ffffff;
    border-radius: 5px;
    color: white;
    background-color: ${({ theme }) => theme.colors.selection};
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  width: 100%;
  gap: var(--sp-16);
`;

export const Button = styled.button`
  position: relative;
  width: 100%;
  height: calc(var(--u) * 50);
  margin-top: var(--sp-20);
  margin-bottom: var(--sp-20);
  border-radius: 6px;
  background-color: #ffe460;
  color: black;
  font-size: var(--fs-xl);
  font-weight: bold;
  cursor: pointer;

  &:hover {
    color: white;
    background-color: #ffc303;
  }
`;

export const PasswordWrapper = styled.div`
  width: 100%;
  position: relative;
  display: flex;
  align-items: center;
`;

export const TogglePasswordButton = styled.button`
  position: absolute;
  width: fit-content;
  right: 0%;
  background: none;
  border: none;
  cursor: pointer;
  color: #007bff;
  display: flex;
`;
export const IconLabel = styled.span`
  font-family: "Material Icons";
  font-size: var(--fs-3xl);
  color: #ffc400;
  margin-right: var(--sp-10);
`;

export const IconInput = styled.span`
  font-family: "Material Icons" !important;
  font-size: var(--fs-2xl);
  margin-right: var(--sp-10);
`;
export const LogIn = styled.div`
  position: absolute;
  top: calc(var(--u) * 30);
  right: calc(var(--u) * 20);
  justify-content: flex-start;
  display: flex;
  align-items: center;
`;

export const LogInText = styled.div`
  color: rgba(0, 0, 0, 0.5);
  margin-right: var(--sp-10);
`;

export const LogInButton = styled.button`
  background: transparent;
  border: 2px solid rgba(0, 0, 0, 0.5);
  border-radius: 15px;
  padding: var(--sp-8) var(--sp-10);
  cursor: pointer;
  transition: 0.3s;
  color: rgba(0, 0, 0, 0.5);
  font-size: var(--fs-xs);
  align-self: flex-end;
  display: inline-flex;
  align-items: center;

  .material-icon {
    font-family: "Material Icons";
    font-size: var(--fs-2xl);
    font-style: normal;
    margin-right: var(--sp-2);
    margin-left: 0px;
  }

  &:hover {
    color: rgba(0, 0, 0, 0.5);
    background: rgba(255, 196, 0, 0.372);
  }
`;

export const Container = styled.div`
  display: flex;
  height: 100vh;
`;

export const Left = styled.div`
  flex: 1;
  background-color: #fff29f;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: var(--sp-20);
  position: relative;
  overflow: hidden;

  &::before,
  &::after {
    content: "";
    position: absolute;
    width: 104.5vw;
    height: 80vw;
    border-radius: 50%;
    background-color: #ffd90050;
    left: -50%;
    transform: translateX(-50%);
  }

  &::before {
    top: 0;
    transform: translateX(-50%) translateY(-50%);
  }

  &::after {
    bottom: 0;
    transform: translateX(-50%) translateY(50%);
  }
`;

export const SvgIconRegister = styled.div`
  position: absolute;
  top: calc(var(--u) * 50);
  width: calc(var(--u) * 100);
  z-index: 1;
  opacity: 0;
  animation: ${fadeIn} 3s forwards;
`;

export const WelcomeText = styled.div`
  z-index: 1;
  color: #ffc400;
  font-size: 4em;
  font-weight: bolder;
  text-align: center;
  opacity: 0;
  animation: ${fadeIn} 1s forwards;
`;

export const DescriptionText = styled.div`
  position: absolute;
  bottom: calc(var(--u) * 20);
  z-index: 1;
  color: #aea04a;
  font-size: var(--fs-base);
`;

// Global Styles for CSS
export const RegisterStyles = createGlobalStyle`
  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
`;
